import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import usersKeys from '../util/users-keys';
import {TranslatedKeys} from 'shared/types/translated-keys';
import {UserProps, translatedUserProps} from '../types';

export interface CreateUserProps extends UserProps {}

export const translatedCreateUserProps: TranslatedKeys<CreateUserProps> =
  translatedUserProps;

const useCreateUser = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: UserProps) => create(usersKeys.list(), data);

  return useApiMutation<UserProps>({
    url: '/users',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar usuário',
    successTitle: 'Cadastrar usuário',
    successMessage: 'Usuário cadastrado com sucesso',
    redirectUrl: '/settings/users',
    onSuccess,
  });
};

export default useCreateUser;
